import { Formik, FormikHelpers } from 'formik'
import { Button, InputField, Modal } from '../../../../../components'
import { LinkModalProps } from '../../types'
import { useNavigate } from 'react-router-dom'
import '../../../sync/pages/index.css'

interface LinkFormValues {
    link: string
}
const CopyLink = ({ show, onClose, link }: LinkModalProps) => {
    const navigate = useNavigate()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Copy the URL"
            body={
                <Formik
                    initialValues={{
                        link: link,
                    }}
                    onSubmit={async (
                        values,
                        actions: FormikHelpers<LinkFormValues>
                    ) => {
                        actions.setSubmitting(false)
                    }}
                >
                    {({ values, isSubmitting }) => (
                        <div className="link-form">
                            <form onSubmit={(e) => e.preventDefault()}>
                                <InputField
                                    type="text"
                                    name=""
                                    lable="URL"
                                    value={values.link}
                                    disabled={true}
                                />
                                <div className="footer-block">
                                    <Button
                                        disabled={isSubmitting}
                                        type="submit"
                                        onClick={() => {
                                            navigator.clipboard.writeText(link)
                                            navigate('/sync')
                                        }}
                                    >
                                        COPY LINK
                                    </Button>
                                    <Button
                                        disabled={isSubmitting}
                                        type="submit"
                                        variant="outline-success"
                                        onClick={() => onClose(false)}
                                    >
                                        CLOSE
                                    </Button>
                                </div>
                            </form>
                        </div>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default CopyLink
